import { checkAuth, resetAuthCache } from './authCheck';

const BASE_URL = process.env.REACT_APP_API_URL;

async function refreshAccessToken() {
    try {
        const data = await checkAuth();

        // Разлогиниваем ТОЛЬКО по явному вердикту сервера. Раньше сюда попадали и
        // сетевые обрывы (VPN, мобильная сеть), и 5xx — и живая сессия стиралась.
        if (data?.status === 'deleted') {
            resetAuthCache();
            localStorage.removeItem('accessToken');
            window.location.href = '/auth';
            return null;
        }

        // Возвращаем актуальный токен из localStorage
        // (checkAuth уже обновил его если был 'unvalid')
        return localStorage.getItem('accessToken');
    } catch (error) {
        // Сетевая/временная ошибка ≠ мёртвая сессия: пробуем со старым токеном,
        // реальный deleted придёт явным статусом при следующей проверке.
        resetAuthCache();
        return localStorage.getItem('accessToken');
    }
}

//
// Следует использовать данную функцию только в том случае,
// если запрос может быть выполнен без перезагрузки страницы,
// иначе валидность токенов проверит соответствующий middleware
//
export const apiFetch = async (url, options = {}) => {
    const fetchUrl = url?.toString()?.toLowerCase()?.includes('http') ? url : `${BASE_URL}${url}`;

    let accessToken = localStorage.getItem('accessToken');

    const headers = { ...options.headers };

    // Гостю заголовок не шлём: 'Bearer null' сервер принимает за попытку
    // авторизации и отвечает 403/deleted вместо обычного «неавторизован».
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
    else delete headers['Authorization'];

    let response = await fetch(fetchUrl, {
        ...options,
        headers,
        credentials: 'include'
    });

    // Обновлять нечего, если сессии нет: для гостя 401/403 на приватном
    // эндпоинте — нормальный ответ, а не повод разлогинивать и уводить на /auth.
    if ((response.status === 401 || response.status === 403) && accessToken) {
        accessToken = await refreshAccessToken();

        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
            response = await fetch(fetchUrl, {
                ...options,
                headers,
                credentials: 'include'
            });
        }
    }

    return response;
};
